import { CeruleanButton } from 'components/Button'
import Column from 'components/Column'
import iconColor from 'components/iconColor'
import FasUserCircle from 'components/Legacy/Icons/FasUserCircle'
import Text from 'components/Text'
import { actions } from 'data'
import messages from 'lang'
import React, { useEffect } from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'

import Container from '../Modal/Container'

const User = styled(FasUserCircle)`
  ${iconColor('blue600')};
  margin-bottom: 1rem;
`

const ColumnTitle = styled(Column)`
  align-items: center;
`

const Col = styled(Column)`
  text-align: center;
`

const Title = styled(Text)`
  margin-bottom: 1rem;
`

const DocType = styled(Text)`
  margin-bottom: 0.5rem;
`

const Info = styled(Text)`
  margin: 2rem 3.5rem 3rem 3.5rem;
`

const PreIdv = ({ intl }: WrappedComponentProps) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(actions.analytics.trackEvent({ key: 'Pre Verification Viewed', properties: {} }))
    return () => {
      dispatch(actions.analytics.trackEvent({ key: 'Pre Verification Dismissed', properties: {} }))
    }
  }, [])

  return (
    <>
      <Container
        sub={intl.formatMessage(messages.sub_title_need_more_verification_info)}
        title={
          <ColumnTitle>
            <User />
            {intl.formatMessage(messages.description_veriff)}
          </ColumnTitle>
        }
        theme='dark'
      >
        <Col>
          <Title color='white' size='lg' weight={600}>
            {intl.formatMessage(messages.youll_need_docs)}
          </Title>
          <DocType color='white' size='md' weight={600}>
            {intl.formatMessage(messages.gov_issued_id)}
          </DocType>
          <DocType color='white' size='md' weight={600}>
            {intl.formatMessage(messages.valid_drivers_license)}
          </DocType>
          <Info color='orange500' size='sm' weight={500}>
            {intl.formatMessage(messages.try_enable_webcam)}
          </Info>
        </Col>
        <CeruleanButton e2e='nextButton' type='submit'>
          {intl.formatMessage(messages.button_next)}
        </CeruleanButton>
      </Container>
    </>
  )
}

export default injectIntl(PreIdv)
